import { _ } from "../../core/polyglot/polyglot.js";
import abstractInvoiceDocument from "./abstractInvoiceDocument.js";
import invoiceColumnsSpec from "./invoiceColumnsSpec.js";

/**
 * `accountsReceivableDocument` is an accounting document responsible
 * for displaying invoices to get money from customers.
 */
export default abstractInvoiceDocument.subclass((that, my) => {
	my.initialize = function (spec) {
		my.super(spec);

		that.title = _("Accounts receivable");
	};

	my.getRepositoryRoute = function () {
		return "/Accounting2/Company/#companyId/InvoiceReport/AccountReceivable";
	};

	my.getColumnSpec = function () {
		return invoiceColumnsSpec.receivableColumnSpec();
	};

	that.hasPeriodPicker = function () {
		return false;
	};

	my.getHelpMessage = function () {
		return _(
			"This report lists the open accounts receivable from the last import date. You can sort this list by clicking on the name of the column you want sorted.",
		);
	};
});
